import React from 'react';

import Container from '@src/components/Shared/Container';
import InlineSVG from '@src/components/Shared/InlineSVG';
import SectionHeader from '@src/components/Shared/SectionHeader';

import { SvgTextPrimaryPropTypes } from './SvgTextPrimary.types';

const SvgTextPrimary: React.FC<SvgTextPrimaryPropTypes> = ({
  id,
  className,
  pretitle,
  title,
  svgURL,
  background = '',
  childrenElements,
  reversed = false,
  titleClassName = '',
  // Passing additional Classes via Props for more flexibility
  svgClassName = '',
  textContainerClassName = '',
  sectionHeaderClassName = '',
}) => {
  return (
    <Container
      id={id}
      className={`flex flex-col gap-[3.2rem] overflow-y-hidden lg:flex-row ${className}`}
      background={background}
    >
      <InlineSVG
        className={`${reversed ? 'lg:order-10' : 'lg:-order-10'} ${svgClassName}`}
        src={svgURL}
        renderAt={['desktop', 'tablet', 'mobile']}
      />

      <div className={`self-center lg:relative lg:z-20 lg:w-[50%] ${textContainerClassName}`}>
        <SectionHeader
          className={`lg:relative lg:z-5 lg:py-[10rem] ${sectionHeaderClassName}`}
          pretitle={pretitle}
          preTitleClassName='mb-[1.6rem] font-normal'
          title={title}
          titleClassName={`text-[2.8rem] leading-[3.2rem] mb-[1.8rem] lg:mb-[3.2rem] lg:text-[4.8rem] lg:leading-[5rem] lg:tracking-[-0.096rem] ${titleClassName}`}
          childrenClassName='relative'
          align='left'
        >
          {childrenElements}
        </SectionHeader>
      </div>
    </Container>
  );
};

export default SvgTextPrimary;
